"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayName = getDisplayName;
exports.deprecateWarn = deprecateWarn;
exports.callHandler = callHandler;

var _types = require("./types");

function getDisplayName(Component) {
  var defaultName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Component';
  return Component.displayName || Component.name || defaultName;
}

function deprecateWarn(Component) {
  var defaultName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Component';
  var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var name = getDisplayName(Component, defaultName);
  console.warn("Warning: ".concat(name, " is deprecated and will be removed or no longer be supported in the future versions. ").concat(message));
}

function callHandler() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }

    if (fns && (0, _types.numberHasLength)(fns.length)) {
      fns.forEach(function (func) {
        if (func) {
          func.apply(void 0, params);
        }
      });
    }
  };
}